<script>
export default {

    name: 'publish-error-modal',

    methods: {
        openModal()
        {
            this.$refs.publishErrorModal.open()
        },
        complete()
        {
            this.$refs.publishErrorModal.close()
        },
        cancel()
        {
            this.$refs.publishErrorModal.close()
        }
    }

}
</script>

<template lang="html">
    <custom-modal exitIcon="fas fa-exclamation-triangle"" ref="publishErrorModal">
        <div slot="header" class="">
            <p class="text-lg font-weight-semibold">
                Publish offer
            </p>
            <h2 class="font-weight-bold mb-0">
                Untitled offer
            </h2>
            <p class="text-desc-color">
                Lover.ly
            </p>
        </div>
        <div>
            <p class="text-lg font-weight-bold">Offer cannot published due to the following errors:</p>
            <ul class="font-awesomed-list pro warning orange m-0">
                <li>
                    Image for desktop is missing
                </li>
                <li>
                    Image for mobile is missing
                </li>
            </ul>
        </div>
        <div slot="footer" class="">
            <custom-button classes="white w-120" text="CANCEL" @buttonClick="cancel"></custom-button>
            <custom-button classes="blue text-white w-120" text="COMPLETE" @buttonClick="complete"></custom-button>
        </div>

    </custom-modal>
</template>



// WEBPACK FOOTER //
// src/components/elements/modals/publishError.vue